module.exports = __webpack_public_path__ + "static/hellosleep-book-1dc5192cec005079cb56ca689870bf3d.jpg";